(function () {
    'use strict';
    var form = document.querySelector('[data-contact-form]');
    if (!form) return;
    var invalid = form.querySelector('[aria-invalid="true"]');
    if (invalid) invalid.focus();
})();
